
























































































import {
  defineComponent,
  onBeforeUnmount,
  onMounted,
  PropType,
  ref,
} from '@nuxtjs/composition-api'
import BlockButtons from '@/components/BlockButtons.vue'
import BlockText from '@/components/BlockText.vue'
import SliderWithButtons from '@/components/SliderWithButtons.vue'

export default defineComponent({
  name: 'SectionSliderImageTextCards',
  components: { BlockText, BlockButtons, SliderWithButtons },
  props: {
    sectionId: {
      type: Object as PropType<{ id?: string }>,
      default: () => ({}),
    },
    innerSections: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const getTextAlignment = (textOrder?: number) => {
      return textOrder === 2 ? 'end' : 'start'
    }

    const getSizes = (card: any) => ({
      sm: [454, card.imageHeightMobile],
      md: [454, card.imageHeightTablet],
      lg: [655, card.imageHeight],
    })

    const activeCard = ref<any | null>(null)

    const openImage = (card: any) => {
      activeCard.value = card
      document.body.style.overflow = 'hidden'
    }

    const closeImage = () => {
      activeCard.value = null
      document.body.style.overflow = ''
    }

    const getSizesOverlay = (card: any) => ({
      sm: [900, card.imageHeightMobile + 500],
      md: [1400, card.imageHeightMobile + 500],
      lg: [1920, card.imageHeightMobile + 500],
    })

    onMounted(() => {
      const onEsc = (e: KeyboardEvent) => {
        if (e.key === 'Escape') closeImage()
      }
      window.addEventListener('keydown', onEsc)

      onBeforeUnmount(() => {
        window.removeEventListener('keydown', onEsc)
      })
    })

    return {
      getSizes,
      getTextAlignment,
      openImage,
      closeImage,
      getSizesOverlay,
      activeCard,
    }
  },
})
